import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rectangle",
  "use": "icon-rectangle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rectangle\"><path d=\"M864 896H160a32 32 0 01-32-32V160a32 32 0 0132-32h704a32 32 0 0132 32v704a32 32 0 01-32 32zm-672-64h640V192H192v640z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol